import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { filter, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactsService {

  private _contactsapiUrl = `${environment.travel}/contacts`
  private _travelapiUrl = `${environment.travel}`;

  constructor(
    private _http: HttpClient
  ) { }

  addContact(formData: FormData): Observable<any> {
    return this._http.post<any>(`${this._contactsapiUrl}/addcontact`, formData);
  }

  getAllContacts(pageNumber: any, pageSize: any, token: any, searchKeyword: any, filters: any): Observable<any> {
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize || 10,
      search: searchKeyword || "",
      filters: filters
    }
    return this._http.post<any>(`${this._travelapiUrl}/contacts`, paginationSettings);
  }

  getAllContactsForLead(leadId: any, pageNumber: any, pageSize: any, token: any): Observable<any> {
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize || 20
    }
    return this._http.post<any>(`${this._contactsapiUrl}/${leadId}`, paginationSettings)
  }

  deleteContactOfLead(contactId: any): Observable<any> {
    return this._http.delete<any>(`${this._contactsapiUrl}/contact/${contactId}`);
  }

  getContact(contactId: any): Observable<any> {
    return this._http.get<any>(`${this._contactsapiUrl}/contact/${contactId}`);
  }

  updateContact(contactId: any, formData: FormData): Observable<any> {
    return this._http.put<any>(`${this._contactsapiUrl}/contact/${contactId}`, formData)
  }

  getContactFromPhoneNumber(phoneNumber: any): Observable<any> {
    return this._http.post<any>(`${this._travelapiUrl}/contactdetails?phone=${phoneNumber}`, {})
  }

  deleteContactAttachment(contactId: any, category: any): Observable<any> {
    return this._http.delete<any>(`${this._contactsapiUrl}/deleteattachment?contactId=${contactId}&category=${category}`);
  }

  // DMC services

  getDmcContacts(pageNumber: any, pageSize: any, token: any, searchValue: any, filters: any): Observable<any> {
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize || 20,
      search: searchValue,
      filters: filters
    }
    return this._http.post<any>(`${this._travelapiUrl}/dmcs`, paginationSettings);
  }

  addDmcContact(formData: any): Observable<any> {
    return this._http.post<any>(`${this._travelapiUrl}/dmcs/adddmc`, formData);
  }

  updateDmcContact(dmcId: any, formData: FormData): Observable<any> {
    return this._http.put<any>(`${this._travelapiUrl}/dmcs/dmc/${dmcId}`, formData)
  }

  getDmcContact(dmcId: any): Observable<any> {
    return this._http.get<any>(`${this._travelapiUrl}/dmcs/dmc/${dmcId}`);
  }

  deleteDmcContact(dmcId: any): Observable<any> {
    return this._http.delete<any>(`${this._travelapiUrl}/dmcs/dmc/${dmcId}`);
  }


  // Vendors Services


  getVendorContacts(pageNumber: any, pageSize: any, token: any, searchValue: any, filters: any): Observable<any> {
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize || 20,
      search: searchValue,
      filters: filters
    }
    return this._http.post<any>(`${this._travelapiUrl}/vendors`, paginationSettings);
  }

  getVendoranddmcsContacts(pageNumber: any, pageSize: any, searchValue: any): Observable<any> {
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize || 20,
      search: searchValue
    }
    return this._http.post<any>(`${this._travelapiUrl}/vendorsanddmcs`, paginationSettings);
  }

  addVendorContact(formData: any): Observable<any> {
    return this._http.post<any>(`${this._travelapiUrl}/vendors/addvendor`, formData);
  }

  updateVendorContact(vendorId: any, formData: FormData): Observable<any> {
    return this._http.put<any>(`${this._travelapiUrl}/vendors/vendor/${vendorId}`, formData)
  }

  getVendorContact(vendorId: any): Observable<any> {
    return this._http.get<any>(`${this._travelapiUrl}/vendors/vendor/${vendorId}`);
  }

  deleteVendorContact(vendorId: any): Observable<any> {
    return this._http.delete<any>(`${this._travelapiUrl}/vendors/vendor/${vendorId}`);
  }

  // Agent Services

  getAgentContacts(pageNumber: any, pageSize: any, token: any, searchValue: any, filters: any): Observable<any> {
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize || 20,
      search: searchValue,
      filters: filters
    }
    return this._http.post<any>(`${this._travelapiUrl}/agents`, paginationSettings);
  }

  addAgentContact(formData: any): Observable<any> {
    return this._http.post<any>(`${this._travelapiUrl}/agent/addagent`, formData);
  }

  updateAgentContact(agentId: any, formData: FormData): Observable<any> {
    return this._http.put<any>(`${this._travelapiUrl}/agents/agent/${agentId}`, formData)
  }

  getAgentContact(agentId: any): Observable<any> {
    return this._http.get<any>(`${this._travelapiUrl}/agents/agent/${agentId}`);
  }

  deleteAgentContact(agentId: any): Observable<any> {
    return this._http.delete<any>(`${this._travelapiUrl}/agents/agent/${agentId}`);
  }

  performBulkActionsForPassengers(req: any): Observable<any> {
    return this._http.put<any>(`${environment.travel}/updatecontacts`, req)
  }
  performBulkActionsForDmc(req: any): Observable<any> {
    return this._http.put<any>(`${environment.travel}/updatedmcs`, req)
  }
  performBulkActionsForVendors(req: any): Observable<any> {
    return this._http.put<any>(`${environment.travel}/updatevendors`, req)
  }
  performBulkActionsForAgents(req: any): Observable<any> {
    return this._http.put<any>(`${environment.travel}/updateagents`, req)
  }

  bulkUploadContacts(req: any): Observable<any> {
    return this._http.post(`${this._travelapiUrl}/uploadcontacts`, req);
  }

}
